<template>
  <div>
    <div v-for="(d, dind) in object.multiple_responsible"
         :key="`dind-${dind}`">
      {{ d.full_name }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  }
})
</script>
